<template>
	<section class="view-venue-hours padded default-panel">
		<ViewLayoutModuleHeader title="Hours of operation">
			<span class="is-open detail tag badge type-danger" v-if="venueModel.isOpenNow()">Open</span>
			<span class="is-closed detail tag badge type-danger" v-else>Closed</span>
		</ViewLayoutModuleHeader>

		<section class="pad-left pad-right">
			<ChalkyVenueHours v-bind:venueModel="venueModel" />
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays the hours of operation for a venue with an open/closed status badge.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueHours extends ViewBase {
		/**
		 * The venue model containing hours data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;
	}
</script>

<style lang="scss">
	.view-venue-hours {
		//
	}
</style>
